// @ts-nocheck

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as AuthenticatedOrgUserManagementImport } from './routes/_authenticated/org-user-management'
import { Route as AuthSsoImport } from './routes/_auth/sso'
import { Route as AuthResetPasswordImport } from './routes/_auth/reset-password'
import { Route as AuthLoginImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordImport } from './routes/_auth/forgot-password'
import { Route as AuthenticatedOrganizationsIndexImport } from './routes/_authenticated/organizations/index'
import { Route as AuthenticatedLibraryIndexImport } from './routes/_authenticated/library/index'
import { Route as AuthenticatedExploreIndexImport } from './routes/_authenticated/explore/index'
import { Route as AuthSsoIndexImport } from './routes/_auth/sso.index'
import { Route as AuthenticatedOrganizationsOrganizationIdImport } from './routes/_authenticated/organizations/$organizationId'
import { Route as AuthenticatedExploreCategoryL1Import } from './routes/_authenticated/explore/$categoryL1'
import { Route as AuthSsoErrorImport } from './routes/_auth/sso.error'
import { Route as AuthSsoCallbackImport } from './routes/_auth/sso.callback'
import { Route as AuthSsoOrgSlugImport } from './routes/_auth/sso.$orgSlug'
import { Route as AuthenticatedLibraryProductsPdpIdImport } from './routes/_authenticated/library/products.$pdpId'
import { Route as AuthenticatedLibraryCollectionsCollectionIdImport } from './routes/_authenticated/library/collections.$collectionId'
import { Route as AuthenticatedLibraryAssetsAssetIdImport } from './routes/_authenticated/library/assets.$assetId'
import { Route as AuthenticatedExploreCategoryL1CategoryL4Import } from './routes/_authenticated/explore/$categoryL1_.$categoryL4'
import { Route as AuthenticatedExploreCategoryL1CategoryL4ClassificationImport } from './routes/_authenticated/explore/$categoryL1_.$categoryL4_.$classification'

// Create/Update Routes

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/_authenticated/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedOrgUserManagementRoute =
  AuthenticatedOrgUserManagementImport.update({
    id: '/_authenticated/org-user-management',
    path: '/org-user-management',
    getParentRoute: () => rootRoute,
  } as any)

const AuthSsoRoute = AuthSsoImport.update({
  id: '/_auth/sso',
  path: '/sso',
  getParentRoute: () => rootRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/_auth/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/_auth/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthForgotPasswordRoute = AuthForgotPasswordImport.update({
  id: '/_auth/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedOrganizationsIndexRoute =
  AuthenticatedOrganizationsIndexImport.update({
    id: '/_authenticated/organizations/',
    path: '/organizations/',
    getParentRoute: () => rootRoute,
  } as any)

const AuthenticatedLibraryIndexRoute = AuthenticatedLibraryIndexImport.update({
  id: '/_authenticated/library/',
  path: '/library/',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedExploreIndexRoute = AuthenticatedExploreIndexImport.update({
  id: '/_authenticated/explore/',
  path: '/explore/',
  getParentRoute: () => rootRoute,
} as any)

const AuthSsoIndexRoute = AuthSsoIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSsoRoute,
} as any)

const AuthenticatedOrganizationsOrganizationIdRoute =
  AuthenticatedOrganizationsOrganizationIdImport.update({
    id: '/_authenticated/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => rootRoute,
  } as any)

const AuthenticatedExploreCategoryL1Route =
  AuthenticatedExploreCategoryL1Import.update({
    id: '/_authenticated/explore/$categoryL1',
    path: '/explore/$categoryL1',
    getParentRoute: () => rootRoute,
  } as any)

const AuthSsoErrorRoute = AuthSsoErrorImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => AuthSsoRoute,
} as any)

const AuthSsoCallbackRoute = AuthSsoCallbackImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthSsoRoute,
} as any)

const AuthSsoOrgSlugRoute = AuthSsoOrgSlugImport.update({
  id: '/$orgSlug',
  path: '/$orgSlug',
  getParentRoute: () => AuthSsoRoute,
} as any)

const AuthenticatedLibraryProductsPdpIdRoute =
  AuthenticatedLibraryProductsPdpIdImport.update({
    id: '/_authenticated/library/products/$pdpId',
    path: '/library/products/$pdpId',
    getParentRoute: () => rootRoute,
  } as any)

const AuthenticatedLibraryCollectionsCollectionIdRoute =
  AuthenticatedLibraryCollectionsCollectionIdImport.update({
    id: '/_authenticated/library/collections/$collectionId',
    path: '/library/collections/$collectionId',
    getParentRoute: () => rootRoute,
  } as any)

const AuthenticatedLibraryAssetsAssetIdRoute =
  AuthenticatedLibraryAssetsAssetIdImport.update({
    id: '/_authenticated/library/assets/$assetId',
    path: '/library/assets/$assetId',
    getParentRoute: () => rootRoute,
  } as any)

const AuthenticatedExploreCategoryL1CategoryL4Route =
  AuthenticatedExploreCategoryL1CategoryL4Import.update({
    id: '/_authenticated/explore/$categoryL1_/$categoryL4',
    path: '/explore/$categoryL1/$categoryL4',
    getParentRoute: () => rootRoute,
  } as any)

const AuthenticatedExploreCategoryL1CategoryL4ClassificationRoute =
  AuthenticatedExploreCategoryL1CategoryL4ClassificationImport.update({
    id: '/_authenticated/explore/$categoryL1_/$categoryL4_/$classification',
    path: '/explore/$categoryL1/$categoryL4/$classification',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_auth/sso': {
      id: '/_auth/sso'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof AuthSsoImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/org-user-management': {
      id: '/_authenticated/org-user-management'
      path: '/org-user-management'
      fullPath: '/org-user-management'
      preLoaderRoute: typeof AuthenticatedOrgUserManagementImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth/sso/$orgSlug': {
      id: '/_auth/sso/$orgSlug'
      path: '/$orgSlug'
      fullPath: '/sso/$orgSlug'
      preLoaderRoute: typeof AuthSsoOrgSlugImport
      parentRoute: typeof AuthSsoImport
    }
    '/_auth/sso/callback': {
      id: '/_auth/sso/callback'
      path: '/callback'
      fullPath: '/sso/callback'
      preLoaderRoute: typeof AuthSsoCallbackImport
      parentRoute: typeof AuthSsoImport
    }
    '/_auth/sso/error': {
      id: '/_auth/sso/error'
      path: '/error'
      fullPath: '/sso/error'
      preLoaderRoute: typeof AuthSsoErrorImport
      parentRoute: typeof AuthSsoImport
    }
    '/_authenticated/explore/$categoryL1': {
      id: '/_authenticated/explore/$categoryL1'
      path: '/explore/$categoryL1'
      fullPath: '/explore/$categoryL1'
      preLoaderRoute: typeof AuthenticatedExploreCategoryL1Import
      parentRoute: typeof rootRoute
    }
    '/_authenticated/organizations/$organizationId': {
      id: '/_authenticated/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationIdImport
      parentRoute: typeof rootRoute
    }
    '/_auth/sso/': {
      id: '/_auth/sso/'
      path: '/'
      fullPath: '/sso/'
      preLoaderRoute: typeof AuthSsoIndexImport
      parentRoute: typeof AuthSsoImport
    }
    '/_authenticated/explore/': {
      id: '/_authenticated/explore/'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof AuthenticatedExploreIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/library/': {
      id: '/_authenticated/library/'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof AuthenticatedLibraryIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/organizations/': {
      id: '/_authenticated/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedOrganizationsIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/explore/$categoryL1_/$categoryL4': {
      id: '/_authenticated/explore/$categoryL1_/$categoryL4'
      path: '/explore/$categoryL1/$categoryL4'
      fullPath: '/explore/$categoryL1/$categoryL4'
      preLoaderRoute: typeof AuthenticatedExploreCategoryL1CategoryL4Import
      parentRoute: typeof rootRoute
    }
    '/_authenticated/library/assets/$assetId': {
      id: '/_authenticated/library/assets/$assetId'
      path: '/library/assets/$assetId'
      fullPath: '/library/assets/$assetId'
      preLoaderRoute: typeof AuthenticatedLibraryAssetsAssetIdImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/library/collections/$collectionId': {
      id: '/_authenticated/library/collections/$collectionId'
      path: '/library/collections/$collectionId'
      fullPath: '/library/collections/$collectionId'
      preLoaderRoute: typeof AuthenticatedLibraryCollectionsCollectionIdImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/library/products/$pdpId': {
      id: '/_authenticated/library/products/$pdpId'
      path: '/library/products/$pdpId'
      fullPath: '/library/products/$pdpId'
      preLoaderRoute: typeof AuthenticatedLibraryProductsPdpIdImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/explore/$categoryL1_/$categoryL4_/$classification': {
      id: '/_authenticated/explore/$categoryL1_/$categoryL4_/$classification'
      path: '/explore/$categoryL1/$categoryL4/$classification'
      fullPath: '/explore/$categoryL1/$categoryL4/$classification'
      preLoaderRoute: typeof AuthenticatedExploreCategoryL1CategoryL4ClassificationImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

interface AuthSsoRouteChildren {
  AuthSsoOrgSlugRoute: typeof AuthSsoOrgSlugRoute
  AuthSsoCallbackRoute: typeof AuthSsoCallbackRoute
  AuthSsoErrorRoute: typeof AuthSsoErrorRoute
  AuthSsoIndexRoute: typeof AuthSsoIndexRoute
}

const AuthSsoRouteChildren: AuthSsoRouteChildren = {
  AuthSsoOrgSlugRoute: AuthSsoOrgSlugRoute,
  AuthSsoCallbackRoute: AuthSsoCallbackRoute,
  AuthSsoErrorRoute: AuthSsoErrorRoute,
  AuthSsoIndexRoute: AuthSsoIndexRoute,
}

const AuthSsoRouteWithChildren =
  AuthSsoRoute._addFileChildren(AuthSsoRouteChildren)

export interface FileRoutesByFullPath {
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sso': typeof AuthSsoRouteWithChildren
  '/org-user-management': typeof AuthenticatedOrgUserManagementRoute
  '/': typeof AuthenticatedIndexRoute
  '/sso/$orgSlug': typeof AuthSsoOrgSlugRoute
  '/sso/callback': typeof AuthSsoCallbackRoute
  '/sso/error': typeof AuthSsoErrorRoute
  '/explore/$categoryL1': typeof AuthenticatedExploreCategoryL1Route
  '/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdRoute
  '/sso/': typeof AuthSsoIndexRoute
  '/explore': typeof AuthenticatedExploreIndexRoute
  '/library': typeof AuthenticatedLibraryIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/explore/$categoryL1/$categoryL4': typeof AuthenticatedExploreCategoryL1CategoryL4Route
  '/library/assets/$assetId': typeof AuthenticatedLibraryAssetsAssetIdRoute
  '/library/collections/$collectionId': typeof AuthenticatedLibraryCollectionsCollectionIdRoute
  '/library/products/$pdpId': typeof AuthenticatedLibraryProductsPdpIdRoute
  '/explore/$categoryL1/$categoryL4/$classification': typeof AuthenticatedExploreCategoryL1CategoryL4ClassificationRoute
}

export interface FileRoutesByTo {
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/org-user-management': typeof AuthenticatedOrgUserManagementRoute
  '/': typeof AuthenticatedIndexRoute
  '/sso/$orgSlug': typeof AuthSsoOrgSlugRoute
  '/sso/callback': typeof AuthSsoCallbackRoute
  '/sso/error': typeof AuthSsoErrorRoute
  '/explore/$categoryL1': typeof AuthenticatedExploreCategoryL1Route
  '/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdRoute
  '/sso': typeof AuthSsoIndexRoute
  '/explore': typeof AuthenticatedExploreIndexRoute
  '/library': typeof AuthenticatedLibraryIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/explore/$categoryL1/$categoryL4': typeof AuthenticatedExploreCategoryL1CategoryL4Route
  '/library/assets/$assetId': typeof AuthenticatedLibraryAssetsAssetIdRoute
  '/library/collections/$collectionId': typeof AuthenticatedLibraryCollectionsCollectionIdRoute
  '/library/products/$pdpId': typeof AuthenticatedLibraryProductsPdpIdRoute
  '/explore/$categoryL1/$categoryL4/$classification': typeof AuthenticatedExploreCategoryL1CategoryL4ClassificationRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sso': typeof AuthSsoRouteWithChildren
  '/_authenticated/org-user-management': typeof AuthenticatedOrgUserManagementRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_auth/sso/$orgSlug': typeof AuthSsoOrgSlugRoute
  '/_auth/sso/callback': typeof AuthSsoCallbackRoute
  '/_auth/sso/error': typeof AuthSsoErrorRoute
  '/_authenticated/explore/$categoryL1': typeof AuthenticatedExploreCategoryL1Route
  '/_authenticated/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdRoute
  '/_auth/sso/': typeof AuthSsoIndexRoute
  '/_authenticated/explore/': typeof AuthenticatedExploreIndexRoute
  '/_authenticated/library/': typeof AuthenticatedLibraryIndexRoute
  '/_authenticated/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/_authenticated/explore/$categoryL1_/$categoryL4': typeof AuthenticatedExploreCategoryL1CategoryL4Route
  '/_authenticated/library/assets/$assetId': typeof AuthenticatedLibraryAssetsAssetIdRoute
  '/_authenticated/library/collections/$collectionId': typeof AuthenticatedLibraryCollectionsCollectionIdRoute
  '/_authenticated/library/products/$pdpId': typeof AuthenticatedLibraryProductsPdpIdRoute
  '/_authenticated/explore/$categoryL1_/$categoryL4_/$classification': typeof AuthenticatedExploreCategoryL1CategoryL4ClassificationRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/sso'
    | '/org-user-management'
    | '/'
    | '/sso/$orgSlug'
    | '/sso/callback'
    | '/sso/error'
    | '/explore/$categoryL1'
    | '/organizations/$organizationId'
    | '/sso/'
    | '/explore'
    | '/library'
    | '/organizations'
    | '/explore/$categoryL1/$categoryL4'
    | '/library/assets/$assetId'
    | '/library/collections/$collectionId'
    | '/library/products/$pdpId'
    | '/explore/$categoryL1/$categoryL4/$classification'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/org-user-management'
    | '/'
    | '/sso/$orgSlug'
    | '/sso/callback'
    | '/sso/error'
    | '/explore/$categoryL1'
    | '/organizations/$organizationId'
    | '/sso'
    | '/explore'
    | '/library'
    | '/organizations'
    | '/explore/$categoryL1/$categoryL4'
    | '/library/assets/$assetId'
    | '/library/collections/$collectionId'
    | '/library/products/$pdpId'
    | '/explore/$categoryL1/$categoryL4/$classification'
  id:
    | '__root__'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/sso'
    | '/_authenticated/org-user-management'
    | '/_authenticated/'
    | '/_auth/sso/$orgSlug'
    | '/_auth/sso/callback'
    | '/_auth/sso/error'
    | '/_authenticated/explore/$categoryL1'
    | '/_authenticated/organizations/$organizationId'
    | '/_auth/sso/'
    | '/_authenticated/explore/'
    | '/_authenticated/library/'
    | '/_authenticated/organizations/'
    | '/_authenticated/explore/$categoryL1_/$categoryL4'
    | '/_authenticated/library/assets/$assetId'
    | '/_authenticated/library/collections/$collectionId'
    | '/_authenticated/library/products/$pdpId'
    | '/_authenticated/explore/$categoryL1_/$categoryL4_/$classification'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSsoRoute: typeof AuthSsoRouteWithChildren
  AuthenticatedOrgUserManagementRoute: typeof AuthenticatedOrgUserManagementRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedExploreCategoryL1Route: typeof AuthenticatedExploreCategoryL1Route
  AuthenticatedOrganizationsOrganizationIdRoute: typeof AuthenticatedOrganizationsOrganizationIdRoute
  AuthenticatedExploreIndexRoute: typeof AuthenticatedExploreIndexRoute
  AuthenticatedLibraryIndexRoute: typeof AuthenticatedLibraryIndexRoute
  AuthenticatedOrganizationsIndexRoute: typeof AuthenticatedOrganizationsIndexRoute
  AuthenticatedExploreCategoryL1CategoryL4Route: typeof AuthenticatedExploreCategoryL1CategoryL4Route
  AuthenticatedLibraryAssetsAssetIdRoute: typeof AuthenticatedLibraryAssetsAssetIdRoute
  AuthenticatedLibraryCollectionsCollectionIdRoute: typeof AuthenticatedLibraryCollectionsCollectionIdRoute
  AuthenticatedLibraryProductsPdpIdRoute: typeof AuthenticatedLibraryProductsPdpIdRoute
  AuthenticatedExploreCategoryL1CategoryL4ClassificationRoute: typeof AuthenticatedExploreCategoryL1CategoryL4ClassificationRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSsoRoute: AuthSsoRouteWithChildren,
  AuthenticatedOrgUserManagementRoute: AuthenticatedOrgUserManagementRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedExploreCategoryL1Route: AuthenticatedExploreCategoryL1Route,
  AuthenticatedOrganizationsOrganizationIdRoute:
    AuthenticatedOrganizationsOrganizationIdRoute,
  AuthenticatedExploreIndexRoute: AuthenticatedExploreIndexRoute,
  AuthenticatedLibraryIndexRoute: AuthenticatedLibraryIndexRoute,
  AuthenticatedOrganizationsIndexRoute: AuthenticatedOrganizationsIndexRoute,
  AuthenticatedExploreCategoryL1CategoryL4Route:
    AuthenticatedExploreCategoryL1CategoryL4Route,
  AuthenticatedLibraryAssetsAssetIdRoute:
    AuthenticatedLibraryAssetsAssetIdRoute,
  AuthenticatedLibraryCollectionsCollectionIdRoute:
    AuthenticatedLibraryCollectionsCollectionIdRoute,
  AuthenticatedLibraryProductsPdpIdRoute:
    AuthenticatedLibraryProductsPdpIdRoute,
  AuthenticatedExploreCategoryL1CategoryL4ClassificationRoute:
    AuthenticatedExploreCategoryL1CategoryL4ClassificationRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth/forgot-password",
        "/_auth/login",
        "/_auth/reset-password",
        "/_auth/sso",
        "/_authenticated/org-user-management",
        "/_authenticated/",
        "/_authenticated/explore/$categoryL1",
        "/_authenticated/organizations/$organizationId",
        "/_authenticated/explore/",
        "/_authenticated/library/",
        "/_authenticated/organizations/",
        "/_authenticated/explore/$categoryL1_/$categoryL4",
        "/_authenticated/library/assets/$assetId",
        "/_authenticated/library/collections/$collectionId",
        "/_authenticated/library/products/$pdpId",
        "/_authenticated/explore/$categoryL1_/$categoryL4_/$classification"
      ]
    },
    "/_auth/forgot-password": {
      "filePath": "_auth/forgot-password.tsx"
    },
    "/_auth/login": {
      "filePath": "_auth/login.tsx"
    },
    "/_auth/reset-password": {
      "filePath": "_auth/reset-password.tsx"
    },
    "/_auth/sso": {
      "filePath": "_auth/sso.tsx",
      "children": [
        "/_auth/sso/$orgSlug",
        "/_auth/sso/callback",
        "/_auth/sso/error",
        "/_auth/sso/"
      ]
    },
    "/_authenticated/org-user-management": {
      "filePath": "_authenticated/org-user-management.tsx"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx"
    },
    "/_auth/sso/$orgSlug": {
      "filePath": "_auth/sso.$orgSlug.tsx",
      "parent": "/_auth/sso"
    },
    "/_auth/sso/callback": {
      "filePath": "_auth/sso.callback.tsx",
      "parent": "/_auth/sso"
    },
    "/_auth/sso/error": {
      "filePath": "_auth/sso.error.tsx",
      "parent": "/_auth/sso"
    },
    "/_authenticated/explore/$categoryL1": {
      "filePath": "_authenticated/explore/$categoryL1.tsx"
    },
    "/_authenticated/organizations/$organizationId": {
      "filePath": "_authenticated/organizations/$organizationId.tsx"
    },
    "/_auth/sso/": {
      "filePath": "_auth/sso.index.tsx",
      "parent": "/_auth/sso"
    },
    "/_authenticated/explore/": {
      "filePath": "_authenticated/explore/index.tsx"
    },
    "/_authenticated/library/": {
      "filePath": "_authenticated/library/index.tsx"
    },
    "/_authenticated/organizations/": {
      "filePath": "_authenticated/organizations/index.tsx"
    },
    "/_authenticated/explore/$categoryL1_/$categoryL4": {
      "filePath": "_authenticated/explore/$categoryL1_.$categoryL4.tsx"
    },
    "/_authenticated/library/assets/$assetId": {
      "filePath": "_authenticated/library/assets.$assetId.tsx"
    },
    "/_authenticated/library/collections/$collectionId": {
      "filePath": "_authenticated/library/collections.$collectionId.tsx"
    },
    "/_authenticated/library/products/$pdpId": {
      "filePath": "_authenticated/library/products.$pdpId.tsx"
    },
    "/_authenticated/explore/$categoryL1_/$categoryL4_/$classification": {
      "filePath": "_authenticated/explore/$categoryL1_.$categoryL4_.$classification.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
